module.exports = __webpack_public_path__ + "img/742ed00.jpg";